import { ADMIN_BASE } from 'enums/adminRoutes';
import PublicRoute from 'enums/publicRoutes';

const PROFILE_BASE = PublicRoute.PROFILE.replace('/:tab', '');

// Pages that require an authenticated session. Only here does an expired
// session force a redirect to login with the session-expired message;
// on the public side the user keeps browsing as a guest.
export const isInProtectedArea = (
  pathname: string = window.location.pathname
): boolean =>
  pathname.startsWith(ADMIN_BASE) || pathname.startsWith(PROFILE_BASE);
